"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./../../SchoolPerformance.module.css"));
function AsherSchoolPerformanceFooter(props) {
    return (react_1.default.createElement("div", { className: styles.footerPosition },
        react_1.default.createElement("p", null,
            "page ",
            props.page,
            " of ",
            props.totalPages)));
}
exports.AsherSchoolPerformanceFooter = AsherSchoolPerformanceFooter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNoZXJTY2hvb2xQZXJmb3JtYW5jZUZvb3Rlci5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9TY2hvb2xQZXJmb3JtYW5jZS9wYXJ0cy9TY2hvb2xQZXJmb3JtYW5jZUZvb3Rlci9Bc2hlclNjaG9vbFBlcmZvcm1hbmNlRm9vdGVyLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLDJFQUE4RDtBQUU5RCxTQUFnQiw0QkFBNEIsQ0FBQyxLQUFLO0lBQzlDLE9BQU8sQ0FDSCx1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLGNBQWM7UUFDakM7O1lBQ1UsS0FBSyxDQUFDLElBQUk7O1lBQU0sS0FBSyxDQUFDLFVBQVUsQ0FDdEMsQ0FDRixDQUNULENBQUE7QUFDTCxDQUFDO0FBUkQsb0VBUUMifQ==